import { ReactNode } from "react";

import { cn } from "@/lib/utils";

import PageHeadTitle from "@/components/Common/PageHeadTitle";

export interface PageTitleProps {
  title: string;
  className?: string;
  componentRight?: ReactNode;
  isInsidePage?: boolean;
  changePageMetadata?: boolean;
  hideTitleOnPage?: boolean;
}

/** Compact page title: h1 with an optional inline element (count badge, status). */
export default function PageTitle({
  title,
  className = "",
  componentRight,
  isInsidePage = false,
  changePageMetadata = true,
  hideTitleOnPage,
}: PageTitleProps) {
  return (
    <div className={cn(!isInsidePage && "mb-2 md:mb-3", className)}>
      {changePageMetadata && <PageHeadTitle title={title} />}
      {!hideTitleOnPage && (
        <div className="flex min-h-9 flex-wrap items-center gap-3">
          <h1 className="text-xl leading-tight font-semibold text-gray-900">
            {title}
          </h1>
          {componentRight}
        </div>
      )}
    </div>
  );
}
